import * as React from "react"
import { PageProps } from "gatsby"
import { StaticImage } from 'gatsby-plugin-image'
// import { GatsbyImage, getImage } from "gatsby-plugin-image"

interface paramIf {
  children: string | any
  color: 'red' | 'green' | 'blue' | undefined
}

export default function Alice({ children, color }: paramIf) {
  const colorName = (function (color) {
    if (color === 'blue') return 'text-blue-800 border-2 border-blue-500 p-5'
    if (color === 'green') return 'text-green-800 border-2 border-green-500 p-5'
    if (color === 'red') return 'text-red-800 border-2 border-red-500 p-5'
    return 'text-green-800 border-2 border-green-500 p-5'
  })(color)
  return (
    <aside>
      <div className={colorName}>
        {children}
      </div>
    </aside>
  )
}
